import { render, staticRenderFns } from "./SpotRoleAggregationWidgetAdapter.global.vue?vue&type=template&id=02ed3e5a&lang=pug&"
import script from "./SpotRoleAggregationWidgetAdapter.global.vue?vue&type=script&lang=ts&"
export * from "./SpotRoleAggregationWidgetAdapter.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports